import { PAGE_SIZE_OPTIONS } from './utils';

export enum SENT_PROMPT_USER_FEEDBACK {
  UPVOTE = 'UPVOTE',
  DOWNVOTE = 'DOWNVOTE',
}

export enum SENT_PROMPT_FEEDBACK_FILTER {
  ALL = 'ALL',
  ANY = 'ANY',
  UPVOTE = 'UPVOTE',
  DOWNVOTE = 'DOWNVOTE',
}

export const SENT_PROMPTS_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];
export const SENT_PROMPTS_DEFAULT_LOOKBACK_DAYS = 7;
export const SENT_PROMPTS_MAX_UNSCOPED_RANGE_DAYS = 31;
export const SENT_PROMPTS_BOUNDED_RANGE_REQUIRED_MESSAGE =
  'Choose both a start and end date before loading workspace-wide history.';
export const SENT_PROMPTS_RANGE_TOO_LARGE_MESSAGE = `Workspace-wide history is limited to ${SENT_PROMPTS_MAX_UNSCOPED_RANGE_DAYS} days at a time. Narrow the date range or filter by organization or user.`;
export const SENT_PROMPTS_REQUEST_TIMEOUT_MS = 30_000;
export const SENT_PROMPTS_LOAD_ERROR_MESSAGE =
  'Sent Prompts could not be loaded. Narrow the filters or retry.';
export const SENT_PROMPTS_EMPTY_TITLE = 'No invocations found';
export const SENT_PROMPTS_EMPTY_DESCRIPTION =
  'No Hana invocations match the selected date range and filters.';
export const SENT_PROMPTS_RETRY_LABEL = 'Retry';
export const SENT_PROMPTS_MESSAGE_BOX_MAX_WIDTH_PERCENTAGE_MD = 70;
export const SENT_PROMPTS_MESSAGE_BOX_MAX_WIDTH_PERCENTAGE_SM = 90;
export const CONSTRUCTED_PROMPT_LABEL = 'Constructed Prompt';
export const VIEW_DETAILS_LABEL = 'View Details';
export const RESPONSE_NOT_AVAILABLE_LABEL = 'Response not available';
export const RESPONSE_DELIVERY_PENDING_LABEL =
  'Delivery pending — no user-facing response is confirmed yet.';
export const RESPONSE_DELIVERY_FAILED_LABEL =
  'Delivery failed — no response was confirmed in Google Chat.';
export const RESPONSE_DELIVERY_PARTIAL_LABEL =
  'Only part of the response was confirmed in Google Chat.';
export const RESPONSE_DELIVERED_NOT_CAPTURED_LABEL =
  'Google Chat delivery was confirmed, but its response content was not captured.';
export const RESPONSE_LEGACY_UNVERIFIED_LABEL =
  'Legacy response — recorded before channel-confirmed delivery tracking.';
export const RESPONSE_LOOKUP_UNAVAILABLE_LABEL =
  'User-facing response lookup is unavailable. Raw model output remains available in details.';
export const USER_FACING_RESPONSE_LABEL = 'User-facing Response';
export const USER_FACING_RESPONSE_DELIVERY_STATUS_LABEL = 'Delivery Status';
export const USER_FACING_RESPONSE_NOT_CAPTURED_LABEL =
  'No user-facing response was captured for this invocation.';
export const MODEL_RESPONSE_LABEL = 'Raw Model Response';
export const TELEMETRY_RUNS_LABEL = 'Model and Tool Telemetry Runs';
export const USER_FACING_RESPONSE_PAYLOAD_LABEL =
  'Exact Outbound Response Payload';
export const START_DATE_LABEL = 'Start Date';
export const END_DATE_LABEL = 'End Date';
export const ORG_LABEL = 'Org';
export const USER_LABEL = 'User';
export const ORGANIZATION_LABEL = 'Organization';
export const ORGANIZATION_ID_LABEL = 'Organization ID';
export const USER_EMAIL_LABEL = 'User Email';
export const USER_ID_LABEL = 'User ID';
export const USER_GOOGLE_ID_LABEL = 'User Google ID';
export const DOMAIN_LABEL = 'Domain';
export const PROMPT_ID_LABEL = 'Invocation ID';
export const SELECTED_DELIVERY_ATTEMPT_ID_LABEL =
  'Latest Confirmed Delivery Attempt ID';
export const CONTRIBUTING_DELIVERY_ATTEMPT_IDS_LABEL =
  'Contributing Delivery Attempt IDs';
export const UPDATED_AT_LABEL = 'Updated At';
export const MODEL_USE_CASE_LABEL = 'Model Use Case';
export const RESPONSE_TIME_MS_LABEL = 'Response Time (ms)';
export const RESPONSE_TAGS_LABEL = 'Response Tags';
export const TOKEN_USAGE_LABEL = 'Token Usage';
export const PROMPT_TOKENS_LABEL = 'Prompt Tokens';
export const COMPLETION_TOKENS_LABEL = 'Completion Tokens';
export const TOTAL_TOKENS_LABEL = 'Total Tokens';
export const PHASE_DURATIONS_LABEL = 'Phase Durations';
export const RAG_MS_LABEL = 'RAG (ms)';
export const ONLINE_SEARCH_MS_LABEL = 'Online Search (ms)';
export const TOTAL_MS_LABEL = 'Total (ms)';
export const DOCUMENT_VERSION_LABEL = 'Document Version';
export const THOUGHT_CHAIN_PARAMS_LABEL = 'Thought Chain Params';
export const ORGANIZATION_PLAN_ID_LABEL = 'Organization Plan ID';
export const ORGANIZATION_PURCHASED_SEATS_LABEL =
  'Organization Purchased Seats';
export const USER_FEEDBACK_LABEL = 'User Feedback';
export const USER_FEEDBACK_UPVOTE_LABEL = 'Upvote';
export const USER_FEEDBACK_DOWNVOTE_LABEL = 'Downvote';
export const USER_FEEDBACK_NONE_LABEL = 'No Feedback';
export const USER_FEEDBACK_ICON_FONT_SIZE_PX = 20;
export const USER_FEEDBACK_CONTAINER_GAP = 1.5;
export const USER_FEEDBACK_CONTAINER_PADDING_Y = 1.5;
export const USER_FEEDBACK_CONTAINER_PADDING_X = 2;
export const USER_FEEDBACK_BORDER_RADIUS = 1.5;
export const USER_FEEDBACK_BORDER_WIDTH_PX = 2;
export const APPLY_FILTERS_BUTTON_LABEL = 'Apply';
export const CORPORATE_ONLY_FILTER_LABEL = 'Corporate Only';
export const USER_FEEDBACK_FILTER_LABEL = 'Feedback Filter';
export const USER_FEEDBACK_FILTER_ALL_LABEL = 'All Responses';
export const USER_FEEDBACK_FILTER_ANY_LABEL = 'Has Like/Unlike';
export const USER_FEEDBACK_FILTER_UPVOTE_LABEL = 'Liked';
export const USER_FEEDBACK_FILTER_DOWNVOTE_LABEL = 'Unliked';
export const EXCLUDED_ORGANIZATION_IDS_LABEL = 'Excluded Organization IDs';
export const ADD_EXCLUDED_ORGANIZATION_ID_LABEL = 'Add';
export const EXCLUDED_ORGANIZATION_ID_PLACEHOLDER = 'Enter organization ID';
export const DUPLICATE_EXCLUDED_ORGANIZATION_ID_MESSAGE =
  'Organization ID already excluded';
export const EMPTY_EXCLUDED_ORGANIZATION_ID_MESSAGE =
  'Please enter an organization ID';
export const SENT_PROMPTS_FILTER_TEXTFIELD_WIDTH_PX = 200;
export const SENT_PROMPTS_FILTER_FIELD_MARGIN_RIGHT = 2;
export const SENT_PROMPTS_EXCLUDED_ORGANIZATION_GAP = 1;
export const SENT_PROMPTS_EXCLUDED_ORGANIZATION_CONTAINER_MARGIN_TOP = 2;
export const SENT_PROMPTS_EXCLUDED_ORGANIZATION_PADDING_Y = 0.5;
export const KEYBOARD_KEY_ENTER = 'Enter';
export const INVALID_DATE_RANGE_ERROR_MESSAGE = 'Invalid date range';

// Loading & skeletons
export const SENT_PROMPTS_SKELETON_COUNT = 3;
export const SENT_PROMPTS_LOADER_HEIGHT_PX = 60;
